import React, { useState, useEffect } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { collection, query, where, orderBy, getDocs } from "firebase/firestore";
import { db } from '../firebase-config';

const sentences =
[
  { content: 'There are no milestones.' },
  { content: 'Raw action solves it all.' },
  { content: 'Relax.' },
  { content: 'Peace.' },
  { content: 'Go an extra mile, it is never crowded there.' },
  { content: 'Exhaustion.' },
  { content: 'Time is valuable.' },
  { content: 'Embrace boredom.' },
  { content: 'Be grateful.' },
  { content: 'There is no tomorrow, There is no tomorrow!' },
  { content: 'Sprint' },
  { content: 'Mad enough' },
  { content: 'MeowwwyyyYaaahhh' },
];

const ProblemSet = ({ Std }) =>
{
  const randomSentence =
    sentences[Math.floor(Math.random() * sentences.length)].content;

  const [problems, setProblems] = useState([]);
  const [loadingProblems, setLoadingProblems] = useState(true);

  const { page } = useParams();
  const pageNumber = parseInt(page.replace("p", ""), 10);
  const navigate = useNavigate();

  const startId = (pageNumber - 1) * 25 + 1;
  const endId = startId + 24;

  useEffect(() =>
  {
    const fetchProblems = async () =>
    {
      setLoadingProblems(true);

      const problemsRef = collection(db, "ProblemSet", Std.toString(), "MCQs");

      const q = query(
        problemsRef,
        where("id", ">=", startId),
        where("id", "<=", endId),
        orderBy("id")
      );

      const snapshot = await getDocs(q);
      const store = snapshot.docs.map(doc => ({
        docId: doc.id,
        ...doc.data()
      }));

      setProblems(store);
      setLoadingProblems(false);
    };

    fetchProblems();
  }, [pageNumber, Std]);

  if (loadingProblems)
  {
    return (
      <div className="mt-20 text-center text-xl sm:text-4xl">
        Loading Questions...
      </div>
    );
  }

  return (
    <div className="w-full mx-auto sm:px-6">

      {/* MOTIVATION */}
      <h2 className="text-lg sm:text-2xl font-extrabold text-white mb-3">
        {randomSentence}
      </h2>

      <div className="bg-white border border-black rounded-xl p-3 sm:p-6 shadow-2xl">

        <h3 className="text-xl sm:text-3xl font-bold text-gray-700 mb-4">
          All Problems
        </h3>

        {/* ================= DESKTOP TABLE ================= */}
        <div className="hidden sm:block overflow-hidden rounded-lg border border-black mb-4">
          <table className="w-full border-collapse">
            <thead className="bg-gray-200">
              <tr>
                <th className="px-6 py-4 text-left text-base font-semibold text-center">
                  Problem
                </th>
                <th className="px-6 py-4 text-left text-base font-semibold text-center">
                  Difficulty
                </th>
              </tr>
            </thead>

            <tbody>
              {problems.map(problem => (
                <tr
                  key={problem.id}
                  className="hover:bg-gray-100 border-b border-gray-400"
                >
                  <td className="px-6 py-4 break-words text-center">
                    <span className="text-blue-600 mr-2 text-lg">
                      {problem.id} .
                    </span>
                    <Link
                      to={`/problems/${problem.id}`}
                      className="text-blue-600 hover:underline text-lg"
                    >
                      {problem.Qname}
                    </Link>
                  </td>

                  <td className="px-6 py-4 text-center">
                    {problem.Difficulty}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* ================= MOBILE CARDS ================= */}
        <div className="sm:hidden space-y-3 mb-4">
          {problems.map(problem => (
            <div
              key={problem.id}
              className="border border-gray-400 rounded-lg p-3"
            >
              <div className="font-semibold break-words">
                <span className="text-blue-600 mr-1">
                  {problem.id}.
                </span>
                <Link
                  to={`/problems/${problem.id}`}
                  className="text-blue-600 hover:underline"
                >
                  {problem.Qname}
                </Link>
              </div>

              <div className="mt-2 text-sm">
                <div><b>Difficulty:</b> {problem.Difficulty}</div>
              </div>
            </div>
          ))}
        </div>

        {/* ================= PAGINATION ================= */}
        <div className="mt-4 flex justify-between items-center gap-2">

          <button
            disabled={pageNumber === 1}
            onClick={() => navigate(`/problemset/p${pageNumber - 1}`)}
            className="px-3 sm:px-4 py-2 border rounded-lg text-sm sm:text-lg bg-yellow-300 disabled:opacity-60"
          >
            Previous
          </button>

          <div className="flex items-center gap-2">
            <span className="text-sm sm:text-lg">
              Page
            </span>
            <input
              type="number"
              min="1"
              value={pageNumber}
              onChange={(e) =>
              {
                const p = Number(e.target.value);
                if (p >= 1)
                {
                  navigate(`/problemset/p${p}`);
                }
              }}
              className="w-16 sm:w-20 text-center border border-gray-400 rounded py-1"
            />
          </div>

          <button
            onClick={() => navigate(`/problemset/p${pageNumber + 1}`)}
            className="px-3 sm:px-4 py-2 border rounded-lg text-sm sm:text-lg bg-green-400"
          >
            Next
          </button>

        </div>
      </div>
    </div>
  );
};

export default ProblemSet;